import type { CampaignTypeConfigList } from './types';

export const ncCampaignTypeConfigList: CampaignTypeConfigList = {
  carinfo: 'ncinfo_carinfo',
  promotion: 'ncinfo_promotion',
  editorial: 'ncinfo_editorial',
  reviews: 'ncinfo_reviews',
  similarcars: 'ncinfo_similarcars',
  recommenddy: 'ncinfo_recommenddy',
  recommendinhouse: 'ncinfo_recommendinhouse',
  tyres: 'ncinfo_tyres',
  leasing: 'ncinfo_leasing',
  discussions: 'ncinfo_discussions',
};
